export enum UserType {
  SUBSCRIPTION = 'subscription',
  ADMIN = 'useradmin',
  USER = 'user'
}

export enum AccountType {
  COMPANY = 'leedflow_company',
  SUBSCRIPTION = UserType.SUBSCRIPTION,
  USER = 'leedflow_simple',
}

export const userTypeAsString = (type: UserType | string): string => {
  switch (type) {
    case UserType.SUBSCRIPTION:
      return "Abonnement";
    case UserType.ADMIN:
      return "Administrateur";
    case UserType.USER:
      return "Utilisateur";
    default:
      return "Type inconnu";
  }
};

export const getBestUserType = (types: UserType[], ignoredTypes: UserType[] = []): UserType => {
  const userTypes = Object.values(UserType)
    .filter(type => !ignoredTypes.includes(type))

  for (const type of userTypes) {
    if (types.includes(type)) {
      return type;
    }
  }

  console.log("NO TYPE FOUND", types);
  return UserType.USER;
};
